import { render, staticRenderFns } from "./scatterCharts.vue?vue&type=template&id=687e742e&"
import script from "./scatterCharts.vue?vue&type=script&lang=js&"
export * from "./scatterCharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports